import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "./routes";
import store from "./store";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  // const requiresDocs = to.matched.some(record => record.meta.requiresDocs);
  const requiresAnyOfRoles =  (to.matched.map(record => record.meta.requiresAnyOfRoles) || [])
    .filter(requiredRoles => !!requiredRoles)
    .reduce((aggregatedList, list) => aggregatedList.concat(list), []);
  let isRouteProhibited =
        (requiresAuth && !store.getters.authenticated) ||
        (requiresAdmin && !store.getters.isAdmin) ||
        (requiresAnyOfRoles.length > 0 && !requiresAnyOfRoles.some(requiredRole => store.getters.hasRole(requiredRole)));
  if (isRouteProhibited) {
    next("/");
  } else {
    next();
  }
});

export default router;
